<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-doubleleft`]" width="1em" height="1em" v-bind="$attrs"><path d="M6.64215 4.02903C6.9017 3.76948 7.32382 3.76977 7.58356 4.02903C7.84325 4.28873 7.84325 4.71074 7.58356 4.97043L4.55426 7.99973L7.58356 11.029L7.66852 11.1335C7.83902 11.3917 7.81082 11.7432 7.58356 11.9704C7.35629 12.1977 7.00477 12.2259 6.74664 12.0554L6.64215 11.9704L3.49664 8.82395C3.04212 8.36895 3.04183 7.63033 3.49664 7.17551L6.64215 4.02903ZM11.9156 4.02903C12.1751 3.76948 12.5973 3.76977 12.857 4.02903C13.1167 4.28873 13.1167 4.71074 12.857 4.97043L9.8277 7.99973L12.857 11.029L12.942 11.1335C13.1125 11.3917 13.0843 11.7432 12.857 11.9704C12.6297 12.1977 12.2782 12.2259 12.0201 12.0554L11.9156 11.9704L8.77008 8.82395C8.31556 8.36895 8.31526 7.63033 8.77008 7.17551L11.9156 4.02903Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineDoubleleft',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
